import React from 'react';
import './VenuePage.css';

import { Heading, PageTitle, Venue } from '../../../components';
import { venues } from '../../../constants';



const VenuePage = () => {
  return (
    <>

      {/* Page Title */}
      <PageTitle title={'Venue Partners'} page={'Venue Partners'} />

      {/* Venue Partners */}
      <section className='venue-partners'>

        {/* Section heading */}
        <Heading title={'Venue Partners'} subTitle={'Our Partner Venues'} />

        <div className='box-container'>

          {/* Map over the venues array to render each venue */}
          {venues.map((venue) => { 
            return (
              <Venue key={venue.id} venue={venue} />
            );
          })}

        </div>

      </section>

    </>
  );
}

export default VenuePage;